import {http} from '@/http/index.js';

export const unsubscribeFromService = async () => {
  return http.post('/consumer/unsubscribe-from-service');
};
